import { POLL_TIMEOUT } from "constants/app";
import { pageLoading } from "slices/app/appSlice";

export const requestPoll =
  (action, getStatusAction, handleSuccess, handleFailure, jobErrorMessage) =>
  async (dispatch) => {
    dispatch(pageLoading(true));
    await action
      .then(async (res) => {
        return new Promise((resolve, reject) => {
          let running = false;
          const timer = setInterval(() => {
            if (running !== true) {
              running = true;
              getStatusAction(res.data.jobId).then((job) => {
                switch (job.data.status) {
                  case "ERROR":
                  case "OUT_OF_SYNC":
                    clearInterval(timer);
                    if (jobErrorMessage) {
                      reject(jobErrorMessage);
                    } else {
                      reject(
                        <>
                          Sorry we can&apos;t do the compare for these files.
                          <br />
                          <br />
                          {job?.data?.jobMetaInfo?.error}
                          <br />
                          <br />
                          To run a successful Compare, you just need to Delete
                          and re-Upload this document.
                        </>
                      );
                    }
                    break;
                  case "COMPLETE":
                    clearInterval(timer);
                    resolve(job);
                    break;
                  case "RUNNING":
                  case "QUEUED":
                  default:
                }
                running = false;
              });
            }
          }, POLL_TIMEOUT);
        }).then((finalResult) => {
          handleSuccess(finalResult);
        });
      })
      .catch((error) => {
        handleFailure(error);
      })
      .finally(() => {
        dispatch(pageLoading(false));
      });
  };
